import { Typography } from "@mui/material";

import { useColors } from "@hooks/useColors";
import { useMediaQueryBreakpoint } from "@hooks/useMediaQueryBreakpoint";

import { CardContainer, CardBackground } from "./MetricCard.styled";

interface MetricCardProps {
  main: string;
  secondary: string;
}

export const MetricCard = ({ main, secondary }: MetricCardProps) => {
  const { isDesktop: isLg, isTablet: isMd } = useMediaQueryBreakpoint();

  const { getColor } = useColors();

  return (
    <CardBackground>
      <CardContainer>
        <Typography
          variant={
            isLg
              ? "paragraph_large_medium"
              : isMd
                ? "paragraph_large_medium"
                : "paragraph_medium_medium"
          }
        >
          {main}
        </Typography>

        <Typography
          color={getColor(c => c.tokens.text["sub-600"])}
          variant={
            isLg
              ? "paragraph_large_regular"
              : isMd
                ? "paragraph_medium_regular"
                : "paragraph_small_regular"
          }
        >
          {secondary}
        </Typography>
      </CardContainer>
    </CardBackground>
  );
};
